import { render } from "./sw-email-select.vue?vue&type=template&id=51df4b03&scoped=true"
import script from "./sw-email-select.vue?vue&type=script&lang=js"
export * from "./sw-email-select.vue?vue&type=script&lang=js"

import "./sw-email-select.vue?vue&type=style&index=0&id=51df4b03&lang=scss"
import "./sw-email-select.vue?vue&type=style&index=1&id=51df4b03&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51df4b03"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QItem,QItemSection,QItemLabel,QChip,QField});
